import { jsx as _jsx } from "react/jsx-runtime";
// Importing 3rd party components
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
// ----------------------------------------------------------------------
const SkeletonStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.35)',
};
// ----------------------------------------------------------------------
// Function to return a random number between 50 and 150
const getRandomNumber = () => {
    return Math.floor(Math.random() * 101) + 50;
};
// ----------------------------------------------------------------------
export const WaveformSkeleton = () => {
    return (_jsx(Stack, { alignItems: "center", flexDirection: "row", gap: "1px", justifyContent: "center", overflow: "hidden", children: [...Array(600)].map((_, i) => (_jsx(Skeleton, { height: getRandomNumber(), width: 1, sx: SkeletonStyle }, i))) }));
};
